import { render, staticRenderFns } from "./jsry.vue?vue&type=template&id=35069056&scoped=true&"
import script from "./jsry.vue?vue&type=script&lang=js&"
export * from "./jsry.vue?vue&type=script&lang=js&"
import style0 from "./jsry.vue?vue&type=style&index=0&id=35069056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35069056",
  null
  
)

export default component.exports